import React from 'react';
import styled from 'styled-components';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { Camera } from '../../canvas/Camera';
import { InlineWidget } from '../../canvas/workspace/widgets/WidgetInterface';

const Frame = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);

    color: white;
    font-size: 12rem;
    font-weight: 500;
`;

export const CountdownWidget = React.memo(({ widget }: { widget: InlineWidget }) => {

    const { viewport } = useObserverReturningStore(useResolve(Camera));
    const style = {
        width: viewport.width,
        height: viewport.height,
    };

    return <Frame style={style}>
        <span>
            {widget.value}
        </span>
    </Frame>;
});
